import React, { useContext } from "react";
import { AppContext } from "../context/AppContext";
import { Button, Card, Col, Row, Typography, Checkbox, Tag, Space } from "antd";
import { CheckCircleOutlined, CrownOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router";
import "./Billing.css"; // Create this file for custom styles

const { Title, Text } = Typography;

const Billing = () => {
  const { user } = useContext(AppContext);

  const navigate = useNavigate();

  const handleUpgrade = (tier) => {
    //navigate to plan checkout page using useNavigate

    navigate(`/planCheckout/${tier}`);
  };

  const plans = [
    {
      tier: "Basic",
      price: "597",
      features: [
        "Up to 100 active loans",
        "Basic reporting",
        "Email support",
        "3 team members",
      ],
      recommended: false,
    },
    {
      tier: "Business",
      price: "1,480",
      features: [
        "Up to 500 active loans",
        "Advanced analytics",
        "Priority support",
        "10 team members",
        "API access",
      ],
      recommended: true,
    },
    {
      tier: "Premium",
      price: "2,818",
      features: [
        "Unlimited loans",
        "Custom reports",
        "24/7 support",
        "Unlimited team",
        "Dedicated account manager",
        "SSO integration",
      ],
      recommended: false,
    },
  ];

  return (
    <div className="billing-container">
      <Title level={2} style={{ textAlign: "center", marginBottom: 8 }}>
        Choose Your Plan
      </Title>
      <Text
        type="secondary"
        style={{ textAlign: "center", display: "block", marginBottom: 40 }}
      >
        14-day money-back guarantee • Cancel anytime
      </Text>

      <Row gutter={[24, 24]} justify="center">
        {plans.map((plan) => (
          <Col xs={24} sm={12} lg={8} key={plan.tier}>
            <Card
              hoverable
              style={{
                border: plan.recommended
                  ? "2px solid #1890ff"
                  : "1px solid #f0f0f0",
                position: "relative",
                height: "100%",
              }}
            >
              {plan.recommended && (
                <Tag
                  icon={<CrownOutlined />}
                  color="#1890ff"
                  style={{
                    position: "absolute",
                    top: -15,
                    right: 20,
                    fontWeight: "bold",
                  }}
                >
                  RECOMMENDED
                </Tag>
              )}

              <div className="plan-header">
                <Title level={3}>{plan.tier}</Title>
                <div className="price">
                  <Text style={{ fontSize: 14 }}>K</Text>
                  <Title level={1} style={{ margin: 0 }}>
                    {plan.price}
                  </Title>
                  <Text type="secondary">/month</Text>
                </div>
              </div>

              <div className="features-list">
                {plan.features.map((feature) => (
                  <Space key={feature} style={{ marginBottom: 8 }}>
                    <CheckCircleOutlined style={{ color: "#52c41a" }} />
                    <Text>{feature}</Text>
                  </Space>
                ))}
              </div>

              <Button
                type={plan.recommended ? "primary" : "default"}
                block
                size="large"
                style={{
                  marginTop: 24,
                  fontWeight: "bold",
                  height: 48,
                }}
                onClick={() => handleUpgrade(plan.tier)}
              >
                {user?.subscription === plan.tier
                  ? "Current Plan"
                  : "Upgrade Now"}
              </Button>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default Billing;
